import { defaultGraficas } from "./state";
import { defaultGraficasFdsMsds } from "./state";

export function asignaEmpresaDash(state, empresa) {
    state.filtro.empresa = empresa;
}

export function setUsuario(state, usuario) {
    state.usuario = usuario;
}
export function load(state, loader) {
    state.loading = loader
}

export function setCargandoDatos(state, cargando_datos_select) {
    state.cargando_datos_select = cargando_datos_select;
}

/**
 * Mutación que carga la información de las graficas.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} info contien la información de nfpa del producto quimico.
 */
export function setGraficas(state, info) {

    state.selectedGraficas.productos = info.Productos;
    state.selectedGraficas.conSga = info.conSga;
    state.selectedGraficas.sinSga = info.sinSga;

    state.selectedGraficas.conNfpa = info.conNfpa;
    state.selectedGraficas.sinNfpa = info.sinNfpa;

    state.selectedGraficas.conUn = info.conUn;
    state.selectedGraficas.sinUn = info.sinUn;

    state.selectedGraficas.cambia = true;
}

/**
 * Mutación que carga la información de las graficasFdsMsds.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} info contien la información de nfpa del producto quimico.
 */
export function setGraficasFdsMsds(state, info) {

    state.selectedGraficasFdsMsds.productos = info.Productos;
    state.selectedGraficasFdsMsds.conFDS = info.conFDS;
    state.selectedGraficasFdsMsds.conMSDS = info.conMSDS;
    state.selectedGraficasFdsMsds.sinAdj = info.sinAdj;

    state.selectedGraficasFdsMsds.porc_con_FDS = info.porc_con_FDS;
    state.selectedGraficasFdsMsds.porc_con_MSDS = info.porc_con_MSDS;
    state.selectedGraficasFdsMsds.porc_sin_Adj = info.porc_sin_Adj;

    state.selectedGraficasFdsMsds.cambia = true;
}

/**
 * Mutación que limpiar  la información de las graficas.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function resetSelectedGraficas(state) {

    Object.assign(state.selectedGraficas, defaultGraficas())
}


/**
 * Mutación que limpiar  la información de las graficasFdsMsds.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function resetSelectedGraficasFdsMsds(state) {

    Object.assign(state.selectedGraficasFdsMsds, defaultGraficasFdsMsds())
}

/**
 * Mutación que carga las notificaciones no leidas.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} notifications contiene las notificaciones.
 */
export function setNotificationsUnread(state) {
    if (JSON.parse(localStorage.getItem('notifylocalStorage')) != null) {
        return state.notifications = JSON.parse(localStorage.getItem('notifylocalStorage'));
    }
}


/**
 * Mutación para setear el tab activo.
 * @param {*} state
 * @param {*} tab
 */
export function setTabActive(state, tab) {
    state.tabActiveCompany = tab
}



/**
 * Mutación que carga la información de las graficas del dashboard1.
 * @param {*} state
 * @param {*} data contiene la información de las graficas.
 */
export function setDataDash1(state, data) {
    data.consulted = true
    state.dataDash1 = data;
}


/**
 * Mutación que carga la información de las graficas del dashboard1.
 * @param {*} state
 * @param {*} data contiene la información de las graficas.
 */
export function setDataDash1Priority(state, data) {
    state.dataDash1.priority = data;
}


/**
 * Mutación para setear el screen activo.
 *
 * @param {*} state
 * @param {*} screen
 */
export function setScreenActive(state, screen) {
    Object.keys(state.screens).forEach(key => state.screens[key] = false);
    state.screens[screen] = true;
}


/**
 * Mutación que carga la información de las graficas del dashboard1.
 * @param {*} state
 * @param {*} data contiene la información de las graficas.
 */
export function setDataDash2(state, data) {
    data.consulted = true
    state.dataDash2 = data;
}

/**
 * Mutación para resetear el flag 'consulted' de dataDash1.
 * @param {Object} state - Estado de Vuex.
 */
export function resetDataDash1Consulted(state) {
    if (state.dataDash1) {
        state.dataDash1.consulted = false;
    }
}

/**
 * Mutación para resetear el flag 'consulted' de dataDash2.
 * @param {Object} state - Estado de Vuex.
 */
export function resetDataDash2Consulted(state) {
    if (state.dataDash2) {
        state.dataDash2.consulted = false;
    }
}

/**
 * Mutación para resetear productsDashAffected.
 * @param {Object} state - Estado de Vuex.
 */
export function resetProductsDashAffected(state) {
    state.productsDashAffected = [];
}

/**
 * Mutación para setear productsDashAffected.
 * @param {Object} state - Estado de Vuex.
 * @param {Object} products - Productos afectados.
 */
export function setProductsDashAffected(state, products) {
    state.productsDashAffected = products;
}

/**
 * Mutación para setear los filtros del dashboard.
 * @param {Object} state - Estado de Vuex.
 * @param {Object} filters - Filtros del dashboard.
 */
export function setDashboardFilters(state, filters) {
    state.dashboardFilters = filters;
}

/**
 * Mutación para resetear los filtros del dashboard.
 * @param {Object} state - Estado de Vuex.
 */
export function resetDashboardFilters(state) {
    state.dashboardFilters = {
        company_id: null,
        slq_location_id: null,
        date_report: null,
        in_use: null,
    };
}
